/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Dialog, FlatButton} from "material-ui";
import service from '../../services/dashboard-services';


class ActionDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleConfirmed = this.handleConfirmed.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saveStatus) {
            this.props.onSaveStatus(nextProps.saveStatus);
        }
    }

    handleConfirmed(data) {
        const {action, domain} = this.props;

        this.props.onCloseDialog();
        this.props.onQueueAction({
            Action: action,
            Domain: domain
        });
    }

    onCloseClick() {
        this.props.onCloseDialog();
    }

    render() {
        const {action, openEdit} = this.props;

        const confirmActions = [
            <FlatButton label="Cancel" primary={true} onTouchTap={this.onCloseClick}/>,
            <FlatButton label="Confirm" secondary={true} onTouchTap={this.handleConfirmed}/>,
        ];

        return (
            <div>

                <Dialog title={action} actions={confirmActions} modal={true} open={openEdit}>
                    Are you sure you want to {action} ?
                </Dialog>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    queue: state.dashboard.queue || {},
    openEdit: state.dashboard.openDialog || false,
    domain: state.dashboard.domain,
    saveStatus: state.dashboard.saveStatus,
    action: state.dashboard.action
});

const mapDispatchToProps = dispatch => ({
    onCloseDialog: () =>
        dispatch({type: 'CLOSE_QUEUE_DIALOG'}),
    onSubmit: (queue) =>
        dispatch({type: 'SUBMIT_QUEUE', payload: service.DashboardServices.saveQueue(queue)}),
    onSaveStatus: (status) =>
        dispatch({type: 'NOTIFY_USER', payload: status}),
    onQueueAction: (data) =>
        dispatch({type: 'QUEUE_ACTION_EXECUTED', payload: service.DashboardServices.runQueueAction(data)})

});

ActionDialog.contextTypes = {
    router: PropTypes.any.isRequired
};

ActionDialog = connect(mapStateToProps, mapDispatchToProps)(ActionDialog);

export default ActionDialog;
